import { render, staticRenderFns } from "./OnboardingLayout.vue?vue&type=template&id=2c18e606"
import script from "./OnboardingLayout.vue?vue&type=script&lang=ts"
export * from "./OnboardingLayout.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingLayout.vue?vue&type=style&index=0&id=2c18e606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports